import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getAllBillingRoles,
  getAllEmployees
} from 'src/services/employeeService';
import { getAllProjects } from 'src/services/projectDetailService';
import { createTeamResource, getTeams } from 'src/services/projectService';
import { AppActions } from 'src/store/AppReducer';
import SearchIcon from '@mui/icons-material/Search';

const AllocateForm = ({
  toggle,
  getData,
  singlePage,
  setSnackBarOpen,
  setSnackBarMessage,
  setSnackbarSeverity
}) => {
  const dispatch = useDispatch();
  const TextFieldStyle = {
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 10,
    marginTop: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const [resourceObj, setResourceObj] = useState<any>({
    employeeId: '',
    name: '',
    startDate: '',
    projectCode: '',
    endDate: '',
    projectRoleCode: '',
    type: '',
    allocation: ''
  });
  const [employees, setEmployees] = useState([]);
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (singlePage) {
      setResourceObj((prev) => ({
        ...prev,
        name: singlePage.name,
        employeeId: singlePage.employeeId
      }));
    }
  }, [singlePage]);

  const getTableData = () => {
    getAllEmployees().then((res) => {
      setEmployees(res.data || []);
    });
  };

  useEffect(() => {
    getTableData();
  }, []);

  useEffect(() => {
    getAllBillingRoles();
  }, []);

  const onClose = () => {
    setResourceObj({
      employeeId: '',
      name: '',
      startDate: '',
      projectCode: '',
      endDate: '',
      projectRoleCode: '',
      type: '',
      allocation: ''
    });
    setSearchText('');
    setSearchText2('');
    toggle();
    onClearErrorMessages();
  };

  //clear inline error messages
  const onClearErrorMessages = ( () => {
    setErrors((prev) => ({
      ...prev,
      nameError: '',
      projectNameError: '',
      startDateError: '',
      endDateError: '',
      projectRoleError: '',
      billingTypeError: '',
      allocationError: ''
    }));
  }) 

  const onCreate = () => {
    const allErrors: any = {};
    if (resourceObj.name === '') {
      allErrors.nameError = 'Name in Jira Required';
    }
    if (resourceObj.projectCode === '') {
      allErrors.projectNameError = 'Project Required';
    }
    if (resourceObj.startDate === '') {
      allErrors.startDateError = 'Start Date Required';
    }
    if (resourceObj.endDate === '') {
      allErrors.endDateError = 'End Date Required';
    }
    if (resourceObj.projectRoleCode === '') {
      allErrors.projectRoleError = 'Project Role Required';
    }
    if (resourceObj.type === '') {
      allErrors.billingTypeError = 'Billing Type Required';
    }
    if (resourceObj.allocation === '') {
      allErrors.allocationError = 'Allocation Required';
    }
    if (Date.parse(resourceObj.startDate) >= Date.parse(resourceObj.endDate)) {
      allErrors.endDateError = 'End date should be greater than start date';
    }

    if (Object.keys(allErrors).length === 0) {
      dispatch(AppActions.showLoader());

      let allData = resourceObj;
      allData.allocation = Number(resourceObj.allocation);
      createTeamResource(allData)
        .then((res) => {
          setSnackBarMessage('You have allocated the resource successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          onClose();
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage('Unable to allocated the user.');
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    } else {
      setErrors(allErrors);
    }
  };

  const [projects, setProjects] = useState([]);
  const [roles, setRoles] = useState([]);

  const getAllProjectDetails = () => {
    getAllProjects().then((res) => {
      setProjects((res.data as any[]) || []);
    });
  };

  useEffect(() => {
    getAllProjectDetails();
  }, []);

  useEffect(() => {
    if (resourceObj?.projectCode) {
      getTeams(resourceObj?.projectCode).then((res) => {
        setRoles(res.data);
      });
    }
  }, [resourceObj]);

  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const [searchText, setSearchText] = useState('');
  const [searchText2, setSearchText2] = useState('');

  const displayedOptions = useMemo(
    () =>
      employees.length > 0 &&
      employees?.filter((option) =>
        containsText(option?.nameInJira, searchText)
      ),
    [searchText, employees]
  );

  const displayedOptions2 = useMemo(
    () =>
      projects.length > 0 &&
      projects?.filter((option) => containsText(option?.name, searchText2)),
    [searchText2, projects]
  );

  return (
    <>
      <Grid sx={{ px: 2, mt: '0.5rem' }} container spacing={2}>
        <Grid item xs={6}>
          <Typography
            sx={{ pb: 1 }}
            variant="h4"
            style={{
              paddingLeft: 10,
              paddingRight: 10,
              fontSize: '15px'
            }}
          >
            Add Resource
          </Typography>
        </Grid>
      </Grid>
      <Grid sx={{ px: 2 }} container spacing={2}>
        {!singlePage && (
          <Grid item xs={6}>
            <Typography variant="h5" style={LabelStyle}>
              Name In Jira
            </Typography>
            <FormControl fullWidth>
              <Select
                size="small"
                displayEmpty
                style={selectStyle}
                defaultValue={''}
                value={resourceObj?.employeeId || ''}
                onChange={(e) => {
                  const target: any = e.target.value;
                  const filteredEmp = employees?.filter(
                    (emp) => emp?.employeeId === target
                  )[0];
                  setResourceObj((prev) => ({
                    ...prev,
                    name: filteredEmp?.nameInJira,
                    employeeId: target
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    nameError: ''
                  }));
                }}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    // Autofocus on textfield
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        // Prevents autoselecting item while typing (default Select behaviour)
                        e.stopPropagation();
                      }
                    }}
                  />
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Name In Jira
                </MenuItem>
                {displayedOptions.length > 0 &&
                  displayedOptions?.map((option, i) => (
                    <MenuItem key={i} value={option.employeeId}>
                      {option.nameInJira}
                    </MenuItem>
                  ))}
              </Select>
              {errors?.nameError && (
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px'
                  }}
                  color="red"
                >
                  {errors?.nameError}&nbsp;
                </Typography>
              )}
            </FormControl>
          </Grid>
        )}
        <Grid item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            Project Name
          </Typography>
          <Select
            size="small"
            displayEmpty
            style={selectStyle}
            defaultValue={''}
            value={resourceObj.projectCode || ''}
            onChange={(e) => {
              setResourceObj((prev) => ({
                ...prev,
                projectCode: e.target.value
              }));
              setErrors((prev) => ({
                ...prev,
                projectNameError: ''
              }));
            }}
          >
            <ListSubheader>
              <TextField
                size="small"
                // Autofocus on textfield
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                onChange={(e) => {
                  setSearchText2(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key !== 'Escape') {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>
            <MenuItem style={{ display: 'none' }} selected disabled value="">
              Select Project Name
            </MenuItem>
            {displayedOptions2.length > 0 &&
              displayedOptions2?.map((option, i) => (
                <MenuItem key={i} value={option.key}>
                  {option.name}
                </MenuItem>
              ))}
          </Select>
          {errors?.projectNameError && (
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {errors?.projectNameError}&nbsp;
            </Typography>
          )}
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            Start Date
          </Typography>
          <TextField
            size="small"
            fullWidth
            placeholder="DD/MM/YYYY"
            type="date"
            style={TextFieldStyle}
            InputLabelProps={{
              shrink: false
            }}
            value={resourceObj.startDate || ''}
            onChange={(e) => {
              setResourceObj((prev) => ({
                ...prev,
                startDate: e.target.value
              }));
              setErrors((prev) => ({
                ...prev,
                startDateError: ''
              }));
            }}
          />
          {errors?.startDateError && (
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {errors?.startDateError}&nbsp;
            </Typography>
          )}
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            End Date
          </Typography>
          <TextField
            size="small"
            fullWidth
            placeholder="DD/MM/YYYY"
            type="date"
            style={TextFieldStyle}
            InputLabelProps={{
              shrink: false
            }}
            value={resourceObj.endDate || ''}
            onChange={(e) => {
              setResourceObj((prev) => ({
                ...prev,
                endDate: e.target.value
              }));
              setErrors((prev) => ({
                ...prev,
                endDateError: ''
              }));
            }}
          />
          {errors?.endDateError && (
            <Typography
              style={{
                paddingLeft: 15,
                paddingRight: 15,
                fontSize: '11px'
              }}
              color="red"
            >
              {errors?.endDateError}&nbsp;
            </Typography>
          )}
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h5" style={LabelStyle}>
            Project Role
          </Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              style={selectStyle}
              displayEmpty
              defaultValue={''}
              value={resourceObj.projectRoleCode || ''}
              onChange={(e) => {
                setResourceObj((prev) => ({
                  ...prev,
                  projectRoleCode: e.target.value
                }));
                setErrors((prev) => ({
                  ...prev,
                  projectRoleError: ''
                }));
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value="">
                Select Project Role
              </MenuItem>
              {(roles || []).map((item, i) => {
                return (
                  <MenuItem value={item.code} key={i}>
                    {`${item.code}: ${item.role}`}
                  </MenuItem>
                );
              })}
            </Select>
            {errors?.projectRoleError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.projectRoleError}&nbsp;
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h5" style={LabelStyle}>
            Billable Type
          </Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              displayEmpty
              style={selectStyle}
              defaultValue={''}
              value={resourceObj.type || ''}
              onChange={(e) => {
                setResourceObj((prev) => ({
                  ...prev,
                  type: e.target.value
                }));
                setErrors((prev) => ({
                  ...prev,
                  billingTypeError: ''
                }));
              }}
            >
              <MenuItem style={{ display: 'none' }} selected disabled value="">
                Billable Type
              </MenuItem>
              <MenuItem value={'Billable'}>Billable</MenuItem>{' '}
              <MenuItem value={'Non-Billable'}>Non-Billable</MenuItem>
              <MenuItem value="Shadow">Shadow</MenuItem>
              <MenuItem value="Support">Support</MenuItem>
              <MenuItem value="T&M">T&M</MenuItem>
            </Select>
            {errors?.billingTypeError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.billingTypeError}&nbsp;
              </Typography>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} variant="h5">
            Allocation (%)
          </Typography>
          <FormControl fullWidth>
            <TextField
              size="small"
              fullWidth
              placeholder="Enter Allocation %"
              style={TextFieldStyle}
              value={resourceObj.allocation || ''}
              InputLabelProps={{
                shrink: false
              }}
              onChange={(e) => {
                setResourceObj((prev) => ({
                  ...prev,
                  allocation: e.target.value
                }));
                setErrors((prev) => ({
                  ...prev,
                  allocationError: ''
                }));
              }}
            />
            {errors?.allocationError && (
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px'
                }}
                color="red"
              >
                {errors?.allocationError}&nbsp;
              </Typography>
            )}
          </FormControl>
        </Grid>

        <Grid
          item
          sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}
          xs={12}
        >
          <Button
            size="small"
            sx={{
              width: '10%',
              background: '#F5F7FF',
              fontSize: '13px',
              fontWeight: 'normal'
            }}
            onClick={() => onClose()}
          >
            Cancel
          </Button>
          <Button
            size="small"
            sx={{
              width: '10%',
              ml: 3,
              fontSize: '13px',
              fontWeight: 'normal',
              background: '#0069E4'
            }}
            variant="contained"
            type="button"
            onClick={() => onCreate()}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AllocateForm;
